import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CategorySection } from "./components/section-category";
import LoaderPage from "components/layout/LoaderPage";
import useCategoryData from "./hooks/use-category-data.hook";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import RelevantSection from "./components/relevant-section";
import useNewsData from "./hooks/use-news-data.hook";
import { useSourceSearch } from "features/SourceSearch";
import useBoclipsSearch from "./hooks/use-boclips-search.hook";
import BoclipsPlayer from "./components/boclips-player";
import { biasRating } from "data/biasRatingLabel";
import { boClipsLabel } from "features/SourceSearch/data/search-fields.data";
import { showBoclipsSearch } from "config";

export default function News() {
  const [loading, setLoading] = useState(true);
  const { currentSearchTerm, currentSource } = useSourceSearch();
  const [boclipsSearch, setBoClipsSearch] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});
  const { source, search } = useParams();
  const [tourNext, setTourNext] = useState(null);

  const { fetchNewsCategoryData, categoriesCopy } = useCategoryData(() => {});
  const { combinedSearch, fetchMore } = useNewsData(
    setLoading,
    search,
    categoriesCopy,
    setLoadingStates
  );
  const { getBoclipsSearchData } = useBoclipsSearch(
    setBoClipsSearch,
    currentSearchTerm,
    setLoadingStates
  );

  const { categories, boclipsPopup } = useSelector((state) => state.data);
  const { isHomeschool } = useSelector((state) => state.account);

  function checkedSource(currentSource) {
    return currentSource == null ? "categories" : currentSource;
  }

  useEffect(() => {
    fetchNewsCategoryData();
  }, [source]);

  useEffect(() => {
    if (((showBoclipsSearch || isHomeschool)) && currentSearchTerm) {
      getBoclipsSearchData(setBoClipsSearch, currentSearchTerm);
    }
  }, [currentSearchTerm]);

  useEffect(() => {
    function triggerAfterDataLoad({ detail }) {
      setTourNext(detail);
    }
    window.addEventListener("tour:app:search:results", triggerAfterDataLoad);
    return () =>
      window.removeEventListener(
        "tour:app:search:results",
        triggerAfterDataLoad
      );
  }, []);

  useEffect(() => {
    if (!loading && tourNext != null) {
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent(tourNext.action, { detail: tourNext.index })
        );
        setTourNext(null);
      }, 1000);
    }
  }, [loading, tourNext]);

  if (!categories.length) {
    return (
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoaderPage />
      </Box>
    );
  }


  console.log("showBoclipsSearch", showBoclipsSearch);
  console.log("isHomeschool", isHomeschool);
  console.log("currentSource", currentSource);

  const augmentedCategories = [
    ...categories.slice(0, 1),
    ...((showBoclipsSearch || isHomeschool) && currentSource !== "partner-publishers"
      ? [{ category_id: "boclips", categoryName_chr: boClipsLabel }]
      : []),
    ...categories.slice(1),
  ];

  return (
    <React.Fragment>
      <RelevantSection />
      {(currentSource === "rating" ? biasRating : augmentedCategories).map(
        (category, index) => {
          const sectionNews =
            combinedSearch.find(
              (search) => search.media === category.categoryName_chr
            ) || null;

          return (
            <Box
              key={category.category_id}
              id={index === 0 ? "tour-first-cat-section" : undefined}
            >
              <CategorySection
                category={category}
                sectionNews={
                  category.category_id !== "boclips"
                    ? sectionNews
                    : boclipsSearch
                }
                source={checkedSource(source)}
                isLoading={loadingStates[category.categoryName_chr] || loading}
                onFetchMore={fetchMore}
              />
            </Box>
          );
        }
      )}
      {boclipsPopup && <BoclipsPlayer />}
    </React.Fragment>
  );
}
